<template>
  <b-container>

        <div class="row no-gutters">
          <div id="col-left-with-text" class="col-sm-12 col-md-12 col-lg-4 ">
            <div class="w-100 position-absolute pl-5 pr-5" style="top: 0; left: 0;">

              <div class="text-left mt-1 mb-2">
                <img class="logo-img" :src="require(`@/assets/images/b122/logo.png`)" alt="Logo Login">
              </div>

              <login-component
                v-if="showLoginComponent"
                ref="loginComponent"
                :showAccountCreationSuccess="showAccountCreationSuccess"
                @showForgotPasswordView="showForgotPasswordView"
                @showSmsCodeView="showSmsCodeView"
                @showRegisterView="showRegisterView"/>

              <sms-code-component
                v-if="showSmsCodeComponent"
                ref="smsCodeComponent"
                @showLoginView="showLoginView"/>

              <validate-account-component
                v-if="showValidateAccountComponent"
                @showLoginView="showLoginView"/>

              <forgot-password-component
                v-if="showForgotPasswordComponent"
                @showLoginView="showLoginView"/>

              <reset-password-component
                v-if="showResetPasswordComponent"
                @showLoginView="showLoginView"/>

              <register-component
                v-if="showRegisterComponent"
                @showLoginView="showLoginView"/>

            </div>
          </div>
          <div id="col-right-with-image" class="col-sm-12 col-md-12 col-lg-8 d-flex flex-row" :style="{'background-image': 'url(' + require(`@/assets/images/b122/login-background.png`) + ')'}">
            <div id="left-banner">
            </div>
          </div>
        </div>

  </b-container>
</template>

<script>

import i18n from '../../i18n'
import LoginComponent from './components/LoginComponent'
import ForgotPasswordComponent from './components/ForgotPasswordComponent'
import ValidateAccountComponent from './components/ValidateAccountComponent'
import SmsCodeComponent from './components/SmsCodeComponent'
import ResetPasswordComponent from './components/ResetPasswordComponent'
import RegisterComponent from "./components/RegisterComponent.vue";

export default {

  name: 'Login',

  components: {
    RegisterComponent,
    ResetPasswordComponent,
    SmsCodeComponent,
    ValidateAccountComponent,
    ForgotPasswordComponent,
    LoginComponent,
    i18n
  },

  data () {
    return {
      currentComponent: this.$route.params.component,
      showAccountCreationSuccess: false
    }
  },

  computed: {
    showLoginComponent () {
      return this.currentComponent ? this.currentComponent === 'login' : true
    },
    showSmsCodeComponent () {
      return this.currentComponent === 'smsCode'
    },
    showValidateAccountComponent () {
      return this.currentComponent === 'validateAccount'
    },
    showForgotPasswordComponent () {
      return this.currentComponent === 'forgotPassword'
    },
    showResetPasswordComponent () {
      return this.currentComponent === 'resetPassword'
    },
    showRegisterComponent () {
      return this.currentComponent === 'register'
    }
  },

  mounted () {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
  },

  methods: {

    showLoginView (accountCreationSuccess = false) {
      this.currentComponent = 'login'
      if (accountCreationSuccess) {
        this.showAccountCreationSuccess = true
      }
    },
    showSmsCodeView (username, password, phoneNumber) {
      this.currentComponent = 'smsCode'
      this.$refs.smsCodeComponent.username = username
      this.$refs.smsCodeComponent.password = password
      this.$refs.smsCodeComponent.phoneNumber = phoneNumber
      this.showAccountCreationSuccess = false
    },
    showValidateAccountView () {
      this.currentComponent = 'validateAccount'
      this.showAccountCreationSuccess = false
    },
    showForgotPasswordView () {
      this.currentComponent = 'forgotPassword'
      this.showAccountCreationSuccess = false
    },
    showResetPasswordView () {
      this.currentComponent = 'resetPassword'
      this.showAccountCreationSuccess = false
    },

    showRegisterView () {
      this.currentComponent = 'register'
      this.showAccountCreationSuccess = false
    }

  }

}

</script>

<style scoped>

b-container {
  padding: 0;
}

.container {
  padding: 0;
}

#col-right-with-image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: top;
  background-position-x: center;
  height: 100vh;
}

#col-left-with-text {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 5px;
  padding-left: 50px;
  height: 100vh;
  max-height: 100vh;
  background-color: white;
  overflow-y: scroll;
}
#col-left-with-text::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
#col-left-with-text {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

@media (max-width: 992px) {
  #col-right-with-image {
    display: none !important;
  }
}
@media (max-width: 500px) {
  #col-left-with-text {
    padding-right: 40px;
    padding-left: 40px;
  }
}
@media (max-height: 700px) {
  #col-left-with-text {
    height: auto;
  }
}

.logo-img {
  max-height: 140px;
}

h1 {
  font-size: var(--title-level-one-font-size);
}
h2 {
  font-size: var(--title-level-two-font-size);
}

#left-banner {
  height: 100%;
  width: 50px;
  background-color: white;
  border-radius: 0 25px 25px 0;
}

a {
  color: var(--main-color);
}

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue